"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyTags = void 0;
const stringifyTags = (tags = []) => tags.map((tag) => `${tag.key}:${tag.value}`).join(', ');
exports.stringifyTags = stringifyTags;
